import { render, staticRenderFns } from "./LogOut.vue?vue&type=template&id=6ec22876"
import script from "./LogOut.vue?vue&type=script&lang=ts"
export * from "./LogOut.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports